
interface SearchResultsStatusBannerProps {
  isAnyLoading: boolean;
  hasErrors: boolean;
  refetchAll: () => void;
}

const SearchResultsStatusBanner = ({ 
  isAnyLoading, 
  hasErrors, 
  refetchAll 
}: SearchResultsStatusBannerProps) => {
  return (
    <>
      {/* Loading state */}
      {isAnyLoading && (
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <div className="flex items-center space-x-3">
            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600"></div>
            <span className="text-blue-800">Actualizando resultados de búsqueda...</span>
          </div>
        </div>
      )}

      {/* Error state */}
      {hasErrors && !isAnyLoading && (
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
          <div className="flex items-center justify-between">
            <span className="text-yellow-800">Algunos calendarios no pudieron ser verificados. Los resultados pueden incluir propiedades no disponibles.</span>
            <button 
              onClick={refetchAll}
              className="text-yellow-600 hover:text-yellow-800 underline text-sm"
            >
              Reintentar
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default SearchResultsStatusBanner;
